<div class="login-container">
  <div class="card">
    <div class="card-header bg-light text-center">
      <div class="row">
        <div class="col-12">
          <img class="login-logo" src="img/Inces_logo.png" alt="">
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <ul class="nav nav-pills card-header-pills">
            <li class="nav-item">
              <a class="nav-link active" id="nav-one-tab" data-bs-toggle="tab" data-bs-target="#frmEntidadTrabajo" type="button" role="tab" aria-controls="nav-one" aria-selected="true">
                Entidad de trabajo
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="nav-two-tab" data-bs-toggle="tab" data-bs-target="#frmAprendiz" type="button" role="tab" aria-controls="nav-two" aria-selected="false">
                Aprendices
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="nav-three-tab" data-bs-toggle="tab" data-bs-target="#frmInstitucional" role="tab" type="button" aria-controls="nav-three" aria-selected="false">
                Institucional
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div id="content-wrap">
        <div class="tab-content" id="nav-tabContent">



          <!-- LOGIN ENTIDAD DE TRABAJO -->
          <div class="tab-pane fade show active" id="frmEntidadTrabajo" role="tabpanel" aria-labelledby="nav-one-tab" tabindex="0">
            <form [formGroup]="frmEntidadTrabajo" autocomplete="off">
              <div class="mb-3">
                <div class="mb-3">
                  <div class="form-group">
                    <label for='correo' class='form-label'>Correo electronico</label>
                    <input type='text' id='mil' formControlName="mil" class='form-control' required>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="form-group">
                  <label for="example-select" class="form-label">
                    Contraseña
                  </label>
                  <div class="input-group">
                    <input type='password' id='password1' formControlName="pass" class='form-control' required>
                    <div class="input-group-append" style="cursor: pointer;" id="ver_pass" (click)="ver_pass(1)">
                       <span class="input-group-text">
                          ver
                       </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-end">
                <a href="#" class="btn btn-light me-2">Cancelar y volver</a>
                <button type="submit" class="btn btn-primary" (click)="login(1)">Aceptar</button>
              </div>
            </form>
          </div>
          <!-- LOGIN APRENDIZ -->
          <div class="tab-pane fade" id="frmAprendiz" role="tabpanel" aria-labelledby="nav-two-tab" tabindex="0">
            <form [formGroup]="frmAprendiz" autocomplete="off">
              <div class="mb-3">
                <div class="mb-3">
                  <div class="form-group">
                    <label for="example-select" class="form-label">
                      Identificacion
                    </label>
                    <div class="input-group">
                      <div class="input-group-append" id="ver_pass">
                        <select class="form-select" id="tp_doc" formControlName="tp_doc"  (change)="validador()">
                          <option value="V" [selected]="true">Venezolano</option>
                          <option value="E">Extranjero</option>
                          <option value="P">Pasaporte</option>
                          <option value="G">Gubernamental</option>
                        </select>
                      </div>
                      <input type='text' id='nro_doc' formControlName="nro_doc" class='form-control' mask="{{mascara}}" required>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="form-group">
                  <label for="example-select" class="form-label">
                    Contraseña
                  </label>
                  <div class="input-group">
                    <input type='password' id='password2' formControlName="pass" class='form-control' required>
                    <div class="input-group-append" style="cursor: pointer;" id="ver_pass" (click)="ver_pass(2)">
                       <span class="input-group-text">
                          ver
                       </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-end">
                <a href="#" class="btn btn-light me-2">Cancelar y volver</a>
                <button type="submit" class="btn btn-primary" (click)="login(2)">Aceptar</button>
              </div>
              <div class="card mt-3 text-center">
                <div class="card-header">
                  <h6>¿Aun no tienes cuenta HACER-PNA?</h6>
                </div>
                <div class="card-body">
                  <a class="btn btn-primary btn-lg" href="https://pna.inces.gob.ve/#/">Registrate</a>
                </div>
              </div>
            </form>
          </div>
          <!-- LOGIN INSTITUCIONAL -->
          <div class="tab-pane fade" id="frmInstitucional" role="tabpanel" aria-labelledby="nav-three-tab" tabindex="0">
            <form [formGroup]="frmInstitucional" autocomplete="off">
              <div class="mb-3">
                <div class="mb-3">
                  <div class="form-group">
                    <label for='correo' class='form-label'>Correo electronico</label>
                    <input type='text' id='correo' formControlName="mil" class='form-control' required>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="form-group">
                  <label for="example-select" class="form-label">
                    Contraseña
                  </label>
                  <div class="input-group">
                    <input type='password' id='password3' formControlName="pass" class='form-control' required>
                    <div class="input-group-append" style="cursor: pointer;" id="ver_pass" (click)="ver_pass(3)">
                       <span class="input-group-text">
                          ver
                       </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-end">
                <a href="#" class="btn btn-light me-2">Cancelar y volver</a>
                <button type="submit" class="btn btn-primary" (click)="login(3)">Aceptar</button>
              </div>
            </form>
          </div>




        </div>
      </div>
    </div>
  </div>
</div>


<app-modal [titulo]="titulo" [tipo_color]="tipo_color" [letra_color]="letra_color" [mensaje]="mensaje"></app-modal>


<ng-template #content let-c="close" let-d="dismiss">
	<div class="modal-header">
		<h4 class="modal-title" id="modal-basic-title">Por favor espere...</h4>
		<!--button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button-->
	</div>
	<div class="modal-body align-self-center">
        <div class="spinner-border d-flex align-self-center" style="width: 3rem; height: 3rem; color: #016E97;" role="status">
            <span class="sr-only"></span>
        </div>
	</div>
	<!--div class="modal-footer">
		<button type="button" class="btn btn-outline-secondary" (click)="c('Save click')">Save</button>
	</div-->
</ng-template>


